module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-update update-form"
  }, [_c('form', {
    staticClass: "organization-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.general_settings')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l organization--base"
  }, [_c('div', [_c('field', {
    staticClass: "two-thirds",
    attrs: {
      "errors": _vm.errors,
      "name": "name",
      "label": "Name",
      "placeholder": "Google inc."
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "is-inline",
    attrs: {
      "errors": _vm.errors,
      "model": "organizations",
      "name": "locale",
      "label": "Language",
      "type": "radio",
      "params": {
        'no_i18n': true
      },
      "collection": [{
        value: 'en',
        name: 'en'
      }, {
        value: 'de',
        name: 'de'
      }]
    },
    model: {
      value: (_vm.item.locale),
      callback: function($$v) {
        _vm.$set(_vm.item, "locale", $$v)
      },
      expression: "item.locale"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "website",
      "label": "Website",
      "placeholder": "http://zombo.com/"
    },
    model: {
      value: (_vm.item.website),
      callback: function($$v) {
        _vm.$set(_vm.item, "website", $$v)
      },
      expression: "item.website"
    }
  }), _vm._v(" "), (_vm.currentUserIsRoot) ? _c('field', {
    attrs: {
      "errors": _vm.errors,
      "label": "Plan",
      "params": {
        no_i18n: true
      },
      "required": true,
      "collection": this.plans,
      "name": "plan",
      "type": "select"
    },
    model: {
      value: (_vm.item.plan),
      callback: function($$v) {
        _vm.$set(_vm.item, "plan", $$v)
      },
      expression: "item.plan"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "company-logo"
  }, [(_vm.company_logo_data) ? _c('img', {
    attrs: {
      "src": _vm.company_logo_data,
      "alt": "logo"
    }
  }) : (_vm.item.company_logo_url) ? _c('img', {
    attrs: {
      "src": _vm.item.company_logo_url,
      "alt": "logo"
    }
  }) : _vm._e(), _vm._v(" "), _c('upload-field', {
    on: {
      "change": _vm.logoUpload
    }
  })], 1), _vm._v(" "), _c('field', {
    staticClass: "is-inline",
    attrs: {
      "errors": _vm.errors,
      "name": "status",
      "type": "radio",
      "params": {
        'no_i18n': true
      },
      "label": "Active organization ?",
      "collection": [{
        value: 'active',
        name: 'Yes'
      }, {
        value: 'inactive',
        name: 'No'
      }]
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.$set(_vm.item, "status", $$v)
      },
      expression: "item.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l organization--address"
  }, [_c('div', [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "street",
      "label": "Street",
      "placeholder": "Hausburgstr"
    },
    model: {
      value: (_vm.item.street),
      callback: function($$v) {
        _vm.$set(_vm.item, "street", $$v)
      },
      expression: "item.street"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "city",
      "label": "City",
      "placeholder": "Berlin"
    },
    model: {
      value: (_vm.item.city),
      callback: function($$v) {
        _vm.$set(_vm.item, "city", $$v)
      },
      expression: "item.city"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grid-2 has-gutter-l"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "street_number",
      "label": "Street number",
      "placeholder": "30"
    },
    model: {
      value: (_vm.item.street_number),
      callback: function($$v) {
        _vm.$set(_vm.item, "street_number", $$v)
      },
      expression: "item.street_number"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "zip",
      "label": "Zip code",
      "placeholder": "10249"
    },
    model: {
      value: (_vm.item.zip),
      callback: function($$v) {
        _vm.$set(_vm.item, "zip", $$v)
      },
      expression: "item.zip"
    }
  })], 1), _vm._v(" "), _c('country-select', {
    attrs: {
      "errors": _vm.errors,
      "name": "country",
      "label": "Country"
    },
    model: {
      value: (_vm.item.country),
      callback: function($$v) {
        _vm.$set(_vm.item, "country", $$v)
      },
      expression: "item.country"
    }
  })], 1)]), _vm._v(" "), (_vm.type == 'update') ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.configuration')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 organization--configuration"
  }, [_c('div', [(_vm.configuration.ranking_display) ? _c('form-switch', {
    attrs: {
      "model": "organization_configuration",
      "name": "ranking_display"
    },
    model: {
      value: (_vm.configuration.ranking_display.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.ranking_display, "content", $$v)
      },
      expression: "configuration.ranking_display.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.configuration.enrichment_disabled) ? _c('form-switch', {
    attrs: {
      "reverse": true,
      "model": "organization_configuration",
      "name": "enrichment_disabled"
    },
    model: {
      value: (_vm.configuration.enrichment_disabled.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.enrichment_disabled, "content", $$v)
      },
      expression: "configuration.enrichment_disabled.content"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.api')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l"
  }, [_c('div', [(_vm.configuration.eventbaxx_auth_token) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "eventbaxx_auth_token",
      "set_state": "api"
    },
    model: {
      value: (_vm.configuration.eventbaxx_auth_token.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.eventbaxx_auth_token, "content", $$v)
      },
      expression: "configuration.eventbaxx_auth_token.content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configuration.api_token_eventbaxx) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "api_token_eventbaxx"
    },
    model: {
      value: (_vm.configuration.api_token_eventbaxx.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.api_token_eventbaxx, "content", $$v)
      },
      expression: "configuration.api_token_eventbaxx.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.configuration.mailchimp_api_key) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "mailchimp_api_key"
    },
    model: {
      value: (_vm.configuration.mailchimp_api_key.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.mailchimp_api_key, "content", $$v)
      },
      expression: "configuration.mailchimp_api_key.content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configuration.xing_consumer_key) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "xing_consumer_key"
    },
    model: {
      value: (_vm.configuration.xing_consumer_key.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.xing_consumer_key, "content", $$v)
      },
      expression: "configuration.xing_consumer_key.content"
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "organization-update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    attrs: {
      "data-action": "organization.cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit",
      "data-action": "organization.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b25ea5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/organizations/OrganizationUpdate.vue
// module id = 1874
// module chunks = 0